<div class="locator-container">
        <table>
            <tr class="row-title">
                <ng-container *ngFor="let control of form.controls |keyvalue;let i=index">
                    <td class="col-title" [matTooltip]="getTooltipFor(control.key)"> {{getTooltipFor(control.key)}}
		                
                    </td>
                </ng-container>
                <td></td>
            </tr>
            <tr>
                <ng-container *ngFor="let control of form.controls |keyvalue;let i=index">
                    <td>
                        <input [formControl]="control.value" 
                        (blur)="input_onblur($event)" 
                        (onchange)="input_onchange($event)" 
                        (keypress)="input_keyPress($event)"
                        class="form-control form-control-sm locator-input" [ngClass]="control.value.invalid ? 'is-invalid' :'' "
                        [matTooltip]="getTooltipFor(control.key)">
		                <div class="invalid-tooltip" *ngIf="control.value.touched && control.value.invalid">Required</div>
                    </td>
                </ng-container>
            </tr>
        </table>
        <div class="btn-find-container">
            <button type="button" class="btn btn-sm btn-outline-primary"
                    (click)="findpanel_click()" matTooltip="Find panel">
                    <i class="fas fa-search"></i> Find panel</button>
        </div>
        <!-- <b class="ml-2">{{uiLocator(issue)}}</b -->
        <!-- {{form?.value|json}} -->
</div>